import React, { useEffect } from 'react'
import AppRoutes from './router'
import { BRAND_NAME, IS_BE_FIT } from './config/branding'

const App = () => {
  useEffect(() => {
    document.title = BRAND_NAME
    const link = document.querySelector("link[rel='icon']")
    if (link) {
      if (IS_BE_FIT) {
        link.href = `${process.env.PUBLIC_URL}/befit-logo.png`
        link.type = 'image/png'
      } else {
        link.href = `${process.env.PUBLIC_URL}/favicon.png`
        link.type = 'image/png'
      }
    }
  }, [])

  return <AppRoutes />
}

export default App
